import React, { useState } from 'react';
import { CheckIcon, ChevronDownIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { volumes } from '../data/volumes';
/** Topics shown per volume before the "+ N more" line. */
const VISIBLE_TOPICS = 6;
export function VolumesSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="volumes" className="defer-paint w-full scroll-mt-6 bg-ink py-10 sm:py-14" aria-labelledby="volumes-heading" data-id="element-216" data-mp="7nbksnmks6g3">
      <div className="mx-auto max-w-4xl px-6" data-id="element-217" data-mp="3c3wbu9swg67e">
        <SectionHeading eyebrow="The complete system" title={<span id="volumes-heading" data-id="element-219" data-mp="3purdp24zdn1h">
              The complete system that organizes your futsal coaching
            </span>} data-id="element-218" data-mp="3c57fm9mchdyi" />

        <p className="mx-auto mt-3 max-w-xl text-center leading-relaxed text-muted" data-id="element-220" data-mp="3l39iyvtjwioy">
          Open any volume and see what to coach, how to run it, where players
          move, what to correct, and how to turn the exercise into real futsal.
        </p>

        <ol className="mt-10 space-y-3" data-id="element-221" data-mp="29fibajtrho0j">
          {volumes.map((volume, index) => {
          const isOpen = openIndex === index;
          const topics = volume.highlights.slice(0, VISIBLE_TOPICS);
          const moreCount = volume.highlights.length - topics.length;
          return <li key={volume.code} className="relative overflow-hidden rounded-3xl border transition-colors duration-150 ease-out" style={{
            borderColor: isOpen ? volume.color : `${volume.color}33`,
            backgroundColor: `${volume.color}0a`
          }} data-id="element-222" data-mp="2j7em8vgy58m6" data-mpi={index}>
                <span className="absolute inset-y-0 left-0 w-1.5" style={{
              backgroundColor: volume.color
            }} aria-hidden="true" data-id="element-223" data-mp="1vg98qmyhasf1" />
                <h3 data-id="element-224" data-mp="24g5t4cdu554a">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`volume-panel-${index}`} className="flex w-full items-center gap-4 rounded-3xl py-4 pl-6 pr-5 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent sm:gap-5 sm:pl-8 sm:pr-6" data-id="element-225" data-mp="24gnt9k3mc3hh">
                    <span className="inline-flex h-12 w-12 shrink-0 items-center justify-center rounded-full font-display text-2xl font-extrabold text-on-cta" style={{
                  backgroundColor: volume.color
                }} aria-hidden="true" data-id="element-226" data-mp="1brq0hzf6x22k">
                      {volume.code}
                    </span>
                    <span className="min-w-0 flex-1" data-id="element-227" data-mp="x2btgxz36wqc">
                      <span className="block font-display text-sm font-semibold uppercase tracking-[0.18em] text-muted" data-id="element-228" data-mp="x0qyj78v1bry">
                        Volume {volume.code} · {volume.count}
                      </span>
                      <span className="mt-0.5 block font-display text-xl font-bold uppercase leading-tight text-fg sm:text-2xl" data-id="element-229" data-mp="16uhlu8t93g62">
                        {volume.name}
                      </span>
                    </span>
                    <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-navy transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-230" data-mp="9divyx2tggtm">
                      <ChevronDownIcon className="h-4 w-4 text-muted" data-id="element-231" data-mp="2prumv1kvgqx0" />
                    </span>
                  </button>
                </h3>

                <div id={`volume-panel-${index}`} className={`grid transition-[grid-template-rows,opacity] duration-200 ease-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-232" data-mp="2c1r5anwxtldw">
                  <div className="overflow-hidden" data-id="element-233" data-mp="34pd5dm6yi7w0">
                    <div className="pb-5 pl-6 pr-5 sm:pl-8 sm:pr-6" data-id="element-234" data-mp="38qgnygge2i0x">
                      <p className="text-[0.98rem] font-medium leading-snug text-fg" data-id="element-235" data-mp="2uqe9z5b7c8qy">{volume.intro}</p>

                      <div className="mt-3.5 grid gap-2.5 sm:grid-cols-[1.35fr_1fr]" data-id="element-236" data-mp="2zpig1n2txqd2">
                        <div className="rounded-2xl px-4 py-3.5" style={{
                      backgroundColor: `${volume.color}14`
                    }} data-id="element-237" data-mp="2zrbrrgsav0rx">
                          <p className="font-display text-xs font-bold uppercase tracking-[0.18em]" style={{
                        color: volume.color
                      }} data-id="element-238" data-mp="1ob4vos7abt1s">
                            Inside
                          </p>
                          <ul className="mt-2 grid grid-cols-2 gap-x-3 gap-y-1.5" data-id="element-239" data-mp="1yrfkvioognis">
                            {topics.map(item => <li key={item} className="flex items-start gap-1.5 text-[0.82rem] font-medium leading-snug text-fg" data-id="element-240" data-mp="1pskdi39wd7dw">
                                <span className="mt-[0.4rem] h-1.5 w-1.5 shrink-0 rounded-full" style={{
                            backgroundColor: volume.color
                          }} aria-hidden="true" data-id="element-241" data-mp="2mj4hhb8j7y5j" />
                                {item}
                              </li>)}
                          </ul>
                          {moreCount > 0 ? <p className="mt-2 text-[0.78rem] font-semibold text-muted" data-id="element-242" data-mp="28itnw0fu85go">
                              + {moreCount} more topics
                            </p> : null}
                        </div>

                        <div className="flex flex-col rounded-2xl bg-navy px-4 py-3.5 ring-1 ring-line" data-id="element-243" data-mp="x5znb655r1bx">
                          <p className="flex items-center gap-1.5 font-display text-xs font-bold uppercase tracking-[0.18em] text-accent" data-id="element-244" data-mp="my52cwrmqwwz">
                            <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-245" data-mp="wxvxn0o0lfy4" />
                            Result
                          </p>
                          <p className="mt-2 text-[0.85rem] font-medium leading-snug text-fg" data-id="element-246" data-mp="11qp0fizxae7k">
                            {volume.result}
                          </p>
                          {volume.note ? <p className="mt-auto pt-3 text-[0.78rem] font-semibold" style={{
                        color: volume.color
                      }} data-id="element-247" data-mp="1arnaahx1lfy2">
                              {volume.note}
                            </p> : null}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>;
        })}
        </ol>
      </div>
    </section>;
}